import React from 'react';

/**
 * Page chrome: title row + optional description + right-side actions.
 */
export default function PageHeader({ title, description, actions, children }) {
    return (
        <div className="px-4 sm:px-8 pt-5 sm:pt-7 pb-4 sm:pb-5 border-b border-[color:var(--bm-border)] bg-white">
            <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-3 sm:gap-6">
                <div className="min-w-0">
                    <h1
                        className="font-display text-[19px] sm:text-[22px] font-semibold text-[color:var(--bm-text)] leading-tight"
                        data-testid="page-title"
                    >
                        {title}
                    </h1>
                    {description && (
                        <p className="text-[13px] text-[color:var(--bm-text-muted)] mt-1.5 max-w-2xl">{description}</p>
                    )}
                </div>
                {actions && <div className="flex items-center gap-2 flex-wrap shrink-0">{actions}</div>}
            </div>
            {children}
        </div>
    );
}
